import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelProper',
})
export class CamelProperPipe implements PipeTransform {
  transform(value: string): any {
    const strArr = [];
    for (let i = 0; i < value.length; i++) {
      const asciiValue = value.charCodeAt(i);
      if (asciiValue >= 65 && asciiValue <= 90) strArr.push(' ');
      strArr.push(i ? value[i] : value[i].toUpperCase());
    }

    return strArr.join('');
  }
}
